import {
  Component,
  EventEmitter,
  Injector,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { BaseComponent } from '@app/shared/base/base-component/base-component.component';
import { AttributeOption } from '@app/shared/interfaces/Attribute';
import { DropDownOption } from '@product/shared/models/GlobalInterfaces';

@Component({
  selector: 'app-attribute-options',
  templateUrl: './attribute-options.component.html',
  styleUrls: ['./attribute-options.component.less'],
})
export class AttributeOptionsComponent extends BaseComponent implements OnInit {

@Input() sectionTitle: string = '';
 @Input() buttonLabel: string = '';

  @Input() listOfOptions: AttributeOption[] = [];
  @Output() optionsChanged = new EventEmitter();
  @Input() record: any;
  @Input() formGroup: FormGroup;
  languages: DropDownOption[] = [];

  tableParams = {
    index: 1,
    size: 10,
  };

  constructor(injector: Injector
  ) {
    super(injector);
  }
 
  fixedIndex: number;
  ngOnInit() {
    setTimeout(() => {
      this.languages = this.commonService.dropDownMetaData['languages'].filter(
        (x) => x.Code !== 0
      );

   
    }, 1000);


  }
  translationChange(index: number, langId: string | number, value: string) {
  
    //const option = this.listOfOptions[index];
    const option = { ...this.listOfOptions[index] };
    
    const translation = option.Translations?.find(
      (x:any) => x.LanguageId == langId
    );
    if (translation) {
      translation.Label = value;
    } else {
      option.Translations = [
        ...(option.Translations ?? []),
        {
          Label: value,
          LanguageId: +langId,
          ObjectField: 'Name',
          ObjectId: this.record?.Id ?? 0,
          ObjectType: 3,
        },
      ];
    }
    
    this.listOfOptions[index] = { ...option };
    this.selectionChanged();
  }
 
  
  
  
  addLineToTable() {
    //
    this.listOfOptions = [
      ...this.listOfOptions,
      {
        Name: '',
        AttributeId: this.record?.Id ?? 0,
        Value: '',
        IsDefault: false,
        Id: 0,
        Translations: [],
      },
    ];
    this.selectionChanged();
  }
  getIndex(j: any): number {
    return (this.tableParams.index - 1) * this.tableParams.size + j ;
  }
  
  selectionChanged() {
    if(this.formGroup){
      this.formGroup.markAsDirty();
      this.formGroup.markAsTouched();
    }
   
    // if (!this.listOfOptions || this.listOfOptions.length === 0) {
    //   console.warn('No options to emit');
    //   return;
    // }

    this.optionsChanged.emit(this.listOfOptions);
  }
  defaultOptionChanged(status: boolean, data: AttributeOption) {
    if (status) {
      this.listOfOptions.map((option) => (option.IsDefault = false));
      const option = this.listOfOptions.find((x) => x === data);
      if (option != null) {
        option.IsDefault = true;
      }
    }
    this.selectionChanged();
  }
  
  deleteOption(index: number) {
    //
    //new 
    this.listOfOptions = [...this.listOfOptions]; 
    this.listOfOptions.splice(index, 1);
    this.selectionChanged();

  }
  trackByFn(index: number, item: any): number {
    return item.Id;  
  }
  onPageChange(pageIndex: number) {
    this.tableParams.index = pageIndex;

  }
  
  

   
}
